import { render, staticRenderFns } from "./AppNotify.vue?vue&type=template&id=30fbcce8"
import script from "./AppNotify.vue?vue&type=script&lang=js"
export * from "./AppNotify.vue?vue&type=script&lang=js"
import style0 from "./AppNotify.vue?vue&type=style&index=0&id=30fbcce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports